export default __webpack_public_path__ + "static/1174-b25ac477a80a9a1225874001e2910715.gif";